// extracted by mini-css-extract-plugin
export default {"title":"Badges_title__1jTSu","desktop":"Badges_desktop__4vp7v","desktop__content":"Badges_desktop__content__SSs9d"};